import axios from "axios";
import { handlePaginatedResponse, createPaginatedStateWithSummary } from '../helpers/paginationState';
export const state = {
    cashout: [],
    cashin: [],
    save_status: false,
    transactions: createPaginatedStateWithSummary(50, {
        totalAmount: 0,
    }),
};
export const getters = {
    CashIn: state => state.cashin.data,
    CashOut: state => state.cashout.data,
    SaveStatus: state => state.save_status,
    GetTransactions: state => state.transactions.data,
    GetTransactionsPagination: state => state.transactions.meta,
    GetTransactionsPaginated: state => state.transactions.data,
    IsGetTransactionsServerPaginated: state => state.transactions.data,
    GetTransactionsSummary: state => state.transactions.summary,


};

export const mutations = {
    SET_CASHIN(state, newValue) {
        state.cashin = newValue
    },
    SET_CASHOUT(state, newValue) {
        state.cashout = newValue
    },
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_TRANSACTIONS(state, response) {
        handlePaginatedResponse(state.transactions, response);
    },

};

export const actions = {
    recordCashin({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('cashin', payload).then((resp) => {
            dispatch('fetchCashin');
            if (resp.status == 201) {
                let message = { 'msg': resp.message }
                dispatch('notification/error', message, { root: true })
            }
            else {
                let message = { 'msg': "Cash in record added successfully" }
                dispatch('notification/success', message, { root: true })
            }
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Cash in record" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit Cashin
    editCashin({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`cashin/${payload.id}`, payload).then(() => {
            dispatch('fetchCashin');
            let message = { 'msg': "Cash in record updated successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Cash in record" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete cashin 
    deleteCashin({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`cashin/${payload.id}`).then(() => {
            dispatch('fetchCashin');
            let message = { 'msg': "Cash in deleted successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Deleting Cash in" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // add Cashout
    recordCashout({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('cashout', payload).then((resp) => {
            dispatch('fetchCashout');
            if (resp.status == 201) {
                let message = { 'msg': resp.message }
                dispatch('notification/error', message, { root: true })
            }
            else {
                let message = { 'msg': "Cash out record added successfully" }
                dispatch('notification/success', message, { root: true })
            }
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Cash out record" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit Cashout
    editCashout({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`cashout/${payload.id}`, payload).then(() => {
            dispatch('fetchCashout');
            let message = { 'msg': "Cash out record updated successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Cash out record" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete cashout 
    deleteCashout({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`cashout/${payload.id}`).then(() => {
            dispatch('fetchCashout');
            let message = { 'msg': "Cash out deleted successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Deleting Cash out" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchCashin({ commit }) {
        axios.get('cashin').then(res => {
            commit('SET_CASHIN', res.data)
        })
    },
    fetchCashout({ commit }) {
        axios.get('cashout').then(res => {
            commit('SET_CASHOUT', res.data)
        })
    },
    fetchTransactions({ commit, dispatch }, payload) {
        // axios.post('transactions', payload).then(res => {
        //     commit('SET_TRANSACTIONS', res.data)
        // })
        commit('SET_SAVE_STATUS', true);
        let apiPayload = { ...payload };
        apiPayload.page = apiPayload.page ?? 1;
        apiPayload.per_page = apiPayload.per_page ?? 50;

        axios.post('transactions', apiPayload).then(response => {
            commit('SET_TRANSACTIONS', response.data);
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_TRANSACTIONS', { data: [], meta: {} });
            commit('SET_SAVE_STATUS', false);
            let errorMsg = 'Failed to load expenses.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

};